import { Product } from "@towersystems/roam-common/lib/generated-types";
import React from "react";

export type AddMainProductFormActionsContextType = {
  onAfterSubmitSuccess: (product: Product) => Promise<void> | void;
};

export const AddMainProductFormActionsContext = React.createContext<
  AddMainProductFormActionsContextType | undefined
>(undefined);
